
import BaseCard from '../base-card/base-card';


export default class ThemesCard extends BaseCard {
  constructor(container) {
    super(container);
    this.selector = '.themes-card';
  }
}
